import { render, staticRenderFns } from "./CreateStudentNotifySms.vue?vue&type=template&id=a4a78a6a&scoped=true"
import script from "./CreateStudentNotifySms.vue?vue&type=script&lang=js"
export * from "./CreateStudentNotifySms.vue?vue&type=script&lang=js"
import style0 from "./CreateStudentNotifySms.vue?vue&type=style&index=0&id=a4a78a6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a78a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4a78a6a')) {
      api.createRecord('a4a78a6a', component.options)
    } else {
      api.reload('a4a78a6a', component.options)
    }
    module.hot.accept("./CreateStudentNotifySms.vue?vue&type=template&id=a4a78a6a&scoped=true", function () {
      api.rerender('a4a78a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/CreateStudentNotifySms.vue"
export default component.exports